// extracted by mini-css-extract-plugin
export default {"container":"PermissionDenied_container__7u0LL"};